import { render, staticRenderFns } from "./CustomizedObjectAnalytic.vue?vue&type=template&id=5da9cbec&scoped=true&"
import script from "./CustomizedObjectAnalytic.vue?vue&type=script&lang=js&"
export * from "./CustomizedObjectAnalytic.vue?vue&type=script&lang=js&"
import style0 from "./CustomizedObjectAnalytic.vue?vue&type=style&index=0&id=5da9cbec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da9cbec",
  null
  
)

export default component.exports